import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

/**
 * Clone order steps.
 *
 * @private
 */
export const updateOrderCountsByDate = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  void,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('rpc/routeplan/orderCounts/update', async (_payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()
    const result = await rpc('rpc/routeplan/orderCounts/update', {
      category: 'rpc',
      type: 'rpc/routeplan/orderCounts/update',
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {cloneOrders}`,
      { tags: ['rpc', 'order'] },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Updating order counts by date Failed`,
      error,
    })
  }
})
